
import { Button } from "@/components/ui/button";
import { useState } from "react";
import { AuthModal } from "./AuthModal";
import { useAuth } from "@/hooks/useAuth"; 
import { LogIn, LogOut } from "lucide-react";

export function AuthButton() {
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);
  const { user, signOut } = useAuth();

  return (
    <>
      {user ? (
        <Button 
          variant="outline" 
          onClick={signOut}
          aria-label="Sign out of your account"
        >
          <LogOut className="mr-2 h-4 w-4" aria-hidden="true" />
          Sign Out
        </Button>
      ) : (
        <Button 
          onClick={() => setIsAuthModalOpen(true)}
          className="bg-primary hover:bg-primary/90 text-white"
          aria-label="Sign in to your account"
        >
          <LogIn className="mr-2 h-4 w-4" aria-hidden="true" />
          Sign In
        </Button>
      )}
      <AuthModal open={isAuthModalOpen} onOpenChange={setIsAuthModalOpen} />
    </>
  );
}
